import {
  LeftBarItem,
  LeftBarTag,
  useLeftBar,
} from "components/Sidebar/LeftBar";
import { useMessageCount } from "hooks/useMessageCount";
import { ComponentProps, useMemo } from "react";
import { ChatCommentsIcon } from "components/icons/ChatCommentsIcon";
import { useLocation } from "react-router-dom";
import { parse, stringify } from "qs";

const IconWithBadge = ({
  messageCount,
  open,
}: {
  messageCount: ReturnType<typeof useMessageCount>;
  open: boolean;
}) => {
  return (
    <div className="t-relative">
      <ChatCommentsIcon />

      {Boolean(messageCount?.messages && !open) &&
        messageCount?.messages &&
        messageCount?.messages > 0 && (
          <span className="t-absolute -t-top-0.5 -t-right-0.5 t-w-2 t-h-2 t-rounded-full t-bg-red t-border t-border-solid t-border-surface" />
        )}
    </div>
  );
};

export const ChatLeftNav = ({
  collapseOnClick,
  ...props
}: Partial<ComponentProps<typeof LeftBarItem>> & {
  collapseOnClick?: boolean;
}) => {
  const messageCount = useMessageCount();
  const { open, setOpen } = useLeftBar();

  const handleChatClick = () => {
    if (collapseOnClick) {
      setOpen?.(false);
    }
  };

  const location = useLocation();
  const parsedSearch = parse(location.search, { ignoreQueryPrefix: true });

  const search = stringify(
    {
      entity: parsedSearch.entity,
      company: parsedSearch.company,
    },
    { skipNulls: true, addQueryPrefix: true }
  );

  const icon = useMemo(
    () => () => <IconWithBadge messageCount={messageCount} open={open} />,
    [messageCount, open]
  );

  return (
    <LeftBarItem
      suffix={
        Boolean(messageCount?.messages) &&
        messageCount?.messages &&
        messageCount?.messages > 0 && (
          <LeftBarTag type="red">
            {messageCount.messages > 99 ? "99+" : messageCount.messages}
          </LeftBarTag>
        )
      }
      to={`/chat${search}`}
      icon={icon}
      {...props}
      onClick={handleChatClick}
    >
      Chat
    </LeftBarItem>
  );
};
